/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Slot_Generation_RemoveInputs */

const en_job_form_slot_generation_remove = /** @type {(inputs: Job_Form_Slot_Generation_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`remove`)
};

const de_job_form_slot_generation_remove = /** @type {(inputs: Job_Form_Slot_Generation_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`entfernen`)
};

/**
* | output |
* | --- |
* | "remove" |
*
* @param {Job_Form_Slot_Generation_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const job_form_slot_generation_remove = /** @type {((inputs?: Job_Form_Slot_Generation_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Slot_Generation_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_slot_generation_remove(inputs)
	return en_job_form_slot_generation_remove(inputs)
});